import React, { useState, useEffect, useRef } from 'react';

import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import { ActionsModal } from '../BroadCompatibility';
import gtm from '@/utils/gtm';

export default function PlugAndPlay() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.PlugAndPlay');
    const { locale } = useRouter();
    const actions = new Array(3).fill(1);
    const [activeContent, setActiveContent] = useState(0);

    const IMGS_MAP: any = {
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1735869068962/125w_plug.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1735869057708/125w_plug_h5.jpg',
        },
    };

    const IMGS = IMGS_MAP[locale] || IMGS_MAP.us;

    const handleBtnClick = (index: number) => {
        const gtmValue = localStorage.getItem(`--125w-plug-open-modal-${index + 1}`) || '';

        if ((!activeContent || activeContent !== index + 1) && !gtmValue) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: t('title'),
                button_name: t(`tip_${index + 1}`),
            });
        }

        if (!!activeContent && activeContent === index + 1) {
            setActiveContent(0);
            return;
        }
        setActiveContent(index + 1);
        localStorage.setItem(`--125w-plug-open-modal-${index + 1}`, `${index + 1}`);
    };

    return (
        <div className={`plug-and-play-125w sp-125w-common ${css['plug-and-play-125w']}`}>
            <EfSpec />
            <div className="info">
                <p className="subtitle">{t('label')}</p>
                <p className="title">{t('title')}</p>
                <p className="desc">
                    {t.rich('desc', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </p>
            </div>
            <div className="plug-and-play-imgs">
                <div className="plug-and-play-imgs-box">
                    <EFPicture src={IMGS.pc} srcPad={IMGS.h5} srcMobile={IMGS.h5} />
                    <div className="imgs-box-bottom">
                        {actions?.map((item: any, index: number) => (
                            <ActionsModal key={index} index={index} content={t(`tip_${index + 1}`)} activeStatus={activeContent} onBtnClick={handleBtnClick} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
